import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CalendarHeader = ({ month, year, week, view, onPrev, onNext, onView }) => {
  const views = ["Week", "Month"];

  return (
    <div className="flex items-center space-x-6 absolute right-0 bottom-2">
      <div className="flex items-center justify-between gap-4 ">
        <button onClick={onPrev} className="text-blue-900 hover:opacity-80">
          <ChevronLeft size={16} />
        </button>

        <span className="font-OpenSansSemiBold text-[16px] leading-6 capitalize text-[#1A2332]">
          {view === "Week" ? `${month} ${year} – Week ${week}` : `${month} ${year}`}
        </span>

        <button onClick={onNext} className="text-blue-900 hover:opacity-80">
          <ChevronRight size={16} />
        </button>
      </div>

      <div className="flex flex-col space-y-1 h-[40px] ">
        <div className="relative inline-flex items-center gap-1 rounded-lg border border-[#E5E8F3] bg-[#F8F9FE] p-1">
          {/* Sliding indicator */}
          <span
            className="absolute top-1 bottom-1 rounded-md border border-[#EEF0F9] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] transition-transform duration-300 ease-out"
            style={{
              width: `calc((100% - 0.5rem - ${(views.length - 1) * 0.25}rem) / ${views.length})`,
              transform: `translateX(calc(${views.indexOf(view)} * (100% + 0.25rem)))`,
            }}
          />
          {views.map((v) => {
            const isActive = view === v;
            return (
              <button
                key={v}
                type="button"
                onClick={() => onView(v)}
                className={`relative z-10 flex-1 rounded-md px-5 py-1.5 text-center font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] transition-colors duration-300 ${
                  isActive ? "text-[#1A2332]" : "text-[#7C829A]"
                }`}
              >
                {v}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
